import { useEffect, useState } from "react";

function computePadding(screenWidth: number): string {
  if (screenWidth >= 992 && screenWidth < 1440) {
    return `${(screenWidth - 569) / 2}px`;
  }
  return "435.5px";
}

export function useResponsivePadding(): [string, number] {
  const [screeninnerWidth, setScreeninnerWidth] = useState(0);
  // 初始值在 SSR 或早期 hydration 阶段计算
  const getInitialPadding = (): string => {
    if (typeof window !== "undefined") {
      return computePadding(window.innerWidth);
    }
    return "435.5px";
  };

  const [padding, setPadding] = useState(getInitialPadding);

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window.innerWidth;
      setScreeninnerWidth(innerWidth);
      setPadding(computePadding(innerWidth));
    };

    handleResize(); // 初次运行

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return [padding, screeninnerWidth];
}
